import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./CompactHomepage.css";

const LowerHomepage = ({ t = {} }) => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <section className="employer-reference-cta">
        <div>
          <h2>{t.title || "Looking to hire skilled workers?"}</h2>
          <p>{t.text || "We are here to provide the best manpower solutions for your business."}</p>
        </div>
        <div className="employer-reference-actions">
          <a href="mailto:pakarabian@icloud.com,info@pakarabian.com">{t.emailRequirements || "Email Requirements"}</a>
          <a href="tel:+923335127407">{t.call || "Call Us Now"}</a>
          <a href="https://wa.me/923335127407" target="_blank" rel="noopener noreferrer"><FaWhatsapp /> {t.whatsapp || "Chat on WhatsApp"}</a>
        </div>
      </section>

      <footer className="reference-slim-footer">
        <span>Copyright {currentYear} {t.copyright || "Pak Arabian Manpower Services."}</span>
        <span>
          {t.designed || "Designed by Pak Arabian Team"} |{" "}
          <a className="development-team-link" href="mailto:laibam45@gmail.com">Contact the Development Team</a>
        </span>
      </footer>
    </>
  );
};

export default LowerHomepage;
